// Used for TaxReport.js
export const SELECTABLE_DOCUMENT_TYPES = [
  { label: "Ventas", value: 1 },
  { label: "Compras", value: 2 },
  { label: "Consolidado", value: 3 },
];

export const PAYMENT_METHODS_IDS = {
  CHECK_4: 4,
  CHECK_5: 5,
};
